import { getWingPoly } from "./index213.js";
import { GetAllBones, RG_TYPE } from "@project-rouge/rg-core";
import { getRgObjectsOfType as getRgObjectsOfType$1 } from "@project-rouge/rg-three";
import { MathUtils } from "three";
import { memo, useMemo } from "react";
import { Line as Line$1 } from "@react-three/drei";
import { Fragment, jsx } from "react/jsx-runtime";
const BuildingFloorLines = memo(({ obj }) => {
	return /* @__PURE__ */ jsx(Fragment, { children: useMemo(() => getRgObjectsOfType$1(obj, RG_TYPE.Building), [obj]).map((b) => /* @__PURE__ */ jsx(PerBuildingFloorLines, { building: b }, b.uuid)) });
});
BuildingFloorLines.displayName = "BuildingFloorLines";
var PerBuildingFloorLines = memo(({ building }) => {
	return /* @__PURE__ */ jsx(Fragment, { children: useMemo(() => GetAllBones(building.data.anatomy), [building]).map((bone) => /* @__PURE__ */ jsx(WingBoundary, {
		bone,
		building
	}, bone.id)) });
});
PerBuildingFloorLines.displayName = "PerBuildingFloorLines";
var WingBoundary = memo(({ building, bone }) => {
	const { wingPoly, levelsAltitude } = useMemo(() => {
		return {
			wingPoly: getWingPoly({
				building,
				bone,
				level: bone.floors - 1
			}),
			levelsAltitude: building.data.levels.filter((lvl) => lvl.bones.includes(bone.id)).map((lvl) => lvl.floorWorldBottom).slice(1, bone.floors)
		};
	}, [
		building,
		bone,
		bone.floors
	]);
	return /* @__PURE__ */ jsx(Fragment, { children: levelsAltitude.map((y) => /* @__PURE__ */ jsx(Line$1, {
		position: [
			0,
			y,
			0
		],
		rotation: [
			90 * MathUtils.DEG2RAD,
			0,
			0
		],
		points: wingPoly,
		color: "#3B3B5F",
		opacity: .3,
		transparent: true
	}, y)) });
});
WingBoundary.displayName = "WingBoundary";
export { BuildingFloorLines };

//# sourceMappingURL=index226.js.map